/*@ngInject*/
const UmModalUtil = function ($rootScope, $uibModal, localization, coreConstant,
                              coreMediator, loadingBarHandler, submissionConstant,
                              submissionStateMediator, $state ) {



    function startPerformanceLog(logAction, submissionId) {
        if (logAction) {
            let message = submissionId.toString();
            $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
        }
    }

    function stopPerformanceLog(logAction, status) {
        if (logAction) {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, status);
        }
    }

        this.showReasonModal = function (submissionId, quoteId, notificationEmailTemplateName, reasonObject, translationRoot, isReasonOptional, logAction, callbackOnClose,
                                         dropdownFilterFunctions, isSecondaryDropdownOptional, showDates, redirectToReturnedSubmission, utcDate) {
            isSecondaryDropdownOptional = _.isUndefined(isSecondaryDropdownOptional) ? true : isSecondaryDropdownOptional;
            localization.getTranslations().then(function (root) {
                var translations = _.get(root, translationRoot);
                if (notificationEmailTemplateName) {
                    coreMediator.getNotificationEmailTemplate(notificationEmailTemplateName, {
                        submissionId: submissionId.toString(),
                        quoteId: quoteId ? quoteId.toString() : null,
                        link: null
                    }).then(show);
                } else {
                    show();
                }

            function show(notificationPreference) {
                let modalInstance = $uibModal.open({
                    templateUrl: '/wizard/reason/reasonModal.tpl.html',
                    controller: 'reasonModalController',
                    backdrop: 'static',
                    windowClass: 'reasonModalContainer',
                    resolve: {
                        primaryDropdown: function () {
                            return {
                                name: _.get(translations, 'reasons'),
                                submissionUri: 'com.firstbest.underwriting.submission.Submission:' + submissionId,
                                quoteUri: quoteId ? 'com.firstbest.underwriting.quote.Quote:' + quoteId : null
                            };
                        },
                        secondaryDropdown: function () {
                            if (!_.get(translations, 'secondaryReasons')) {
                                return null;
                            }

                            return {
                                name: _.get(translations, 'secondaryReasons'),
                                submissionUri: 'com.firstbest.underwriting.submission.Submission:' + submissionId,
                                quoteUri: quoteId ? 'com.firstbest.underwriting.quote.Quote:' + quoteId : null
                            };
                        },
                        options: function () {
                            return {
                                title: notificationPreference && !_.isNil(notificationPreference.title) ? notificationPreference.title : _.get(translations, 'title'),
                                summary: _.get(translations, 'summary'),

                                secondaryLabel: _.get(translations, 'secondaryLabel'),
                                primaryReasonIsOptional: isReasonOptional,
                                secondaryDropdownIsOptional: isSecondaryDropdownOptional,
                                selectedPrimaryReason: isReasonOptional ? {
                                    name: _.get(translations, 'primaryPrompt')
                                } : {
                                    name: (reasonObject && reasonObject.reason) ? reasonObject.reason : _.get(translations, 'primaryPrompt'),
                                    value: (reasonObject && reasonObject.reason) ? reasonObject.reason : null,
                                    ordering: (reasonObject && reasonObject.reason) ? -999 /* for 'Other' field */ : -1
                                },
                                selectedSecondaryReason: _.get(translations, 'secondaryPrompt') ? {
                                    name: _.get(translations, 'secondaryPrompt'),
                                    value: null,
                                    ordering: -1
                                } : null,
                                comments: (reasonObject && reasonObject.details) ? reasonObject.details : '',
                                primaryDropdownFilterFunction: dropdownFilterFunctions ? dropdownFilterFunctions.primaryDropdown : null,
                                secondaryDropdownFilterFunction: dropdownFilterFunctions ? dropdownFilterFunctions.secondaryDropdown : null,
                                showDates: showDates,
                                startDateLabel: _.get(translations, 'startDateLabel'),
                                endDateLabel: _.get(translations, 'endDateLabel'),
                                timezoneMode: utcDate ? 'utc' : 'local'
                            };
                        }
                    }
                });
                modalInstance.result.then(handleClose);
            }

            function handleClose(result) {
                loadingBarHandler.showLoadingBar(translationRoot + '.loadingBar');
                startPerformanceLog(logAction, submissionId);

                $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

                callbackOnClose(result).then(onSuccess, onError);

                function onSuccess(result) {
                    loadingBarHandler.hideLoadingBar();
                    stopPerformanceLog(logAction, coreConstant.uiPeformanceLogger.SUCCESS);
                    if (redirectToReturnedSubmission) {
                        let params = {submissionId: result.id},
                            stateName = 'submission.default';

                        $state.go(stateName, params);
                    }

                }

                function onError() {
                    loadingBarHandler.hideLoadingBar();
                    stopPerformanceLog(logAction, coreConstant.uiPeformanceLogger.FAIL);
                }
            }
        });
    };

        this.showReasonFormModel = function (submission, reasonFormId, confirmActionCallback, cancelActionCallback, localizationRoot, logAction) {
            $uibModal.open({
                templateUrl: '/wizard/reason/form/reasonFormModal.tpl.html',
                controller: 'reasonFormModalController',
                windowClass: 'reasonFormModal',
                resolve: {
                    submission: function () {
                        return submission;
                    },
                    reasonFormId: function () {
                        return reasonFormId;
                    },
                    confirmActionCallback: function () {
                        return confirmActionCallback;
                    },
                    cancelActionCallback: function () {
                        return cancelActionCallback;
                    },
                    localizationRoot: function () {
                        return localizationRoot;
                    },
                    logAction: function () {
                        return logAction;
                    }
                },
                keyboard: false,
                backdrop: 'static'
            });
        };

        this.showReasonFormModal = function (submission, reasonFormId, confirmActionCallback, cancelActionCallback, localizationRoot, logAction) {
            $uibModal.open({
                templateUrl: '/wizard/reason/form/reasonFormModal.tpl.html',
                controller: 'reasonFormModalController',
                backdrop: 'static',
                windowClass: 'reasonFormModal',
                resolve: {
                    submission: function () {
                        return submission;
                    },
                    reasonFormId: function () {
                        return reasonFormId;
                    },
                    confirmActionCallback: function () {
                        return confirmActionCallback;
                    },
                    cancelActionCallback: function () {
                        return cancelActionCallback;
                    },
                    localizationRoot: function () {
                        return localizationRoot;
                    },
                    logAction: function () {
                        return logAction;
                    }
                },
                keyboard: false,
                backdrop: 'static'
            });
        };

    };

angular.module('umCore')
    .service('umModalUtil', UmModalUtil);
